module.exports = __webpack_public_path__ + "img/1547151103.e560085e.jpg";